import React, { Component } from 'react';
import './App.css';

import { Grid, Row, Col, Image, Jumbotron, Button, ListGroup, ListGroupItem, ResponsiveEmbed } from 'react-bootstrap'

//images
import coverImg from './imgs/cover.jpg';

import forestImg from './imgs/level-forest.jpg';
import leverImg from './imgs/lever.jpg';
import cryptImg from './imgs/long-crypt.jpg';

class App extends Component {
  render() {
    return (
      <React.Fragment>
        <Grid>
          <Row>
            <Col md={12}>
              <ResponsiveEmbed a16by9>
                <embed src="https://player.vimeo.com/video/261852887" />
              </ResponsiveEmbed>
            </Col>
          </Row>
        </Grid>

        <Grid>
          <Row>
            <Col md={8} mdOffset={2}>
              <Jumbotron className="center">
                <h1>Hell Hath No Fury</h1>
                <p>Hell Hath No Fury is a PC game that follows a young woman
  who is out for revenge and the return of her children which
  have been taken by norse mythology creatures called
Draugrs.</p>
              </Jumbotron>
            </Col>
            <Col>
              <Image className="cover-img" src={coverImg} />
            </Col>
          </Row>
        </Grid>

        <Grid>
          <Row>
            <Col md={8} mdOffset={2}>
              <Jumbotron className="center">
                <h1>How to play</h1>
                <p>The game is currently only available for windows, download &amp; unzip the package, then run the .exe file and enjoy 😄</p>
                <Button target="_blank" download href="https://drive.google.com/uc?export=download&confirm=mFWX&id=1dhw_aqxjTefwYQQUn2qdDXedzP4Sqesy" bsSize="lg">
                  Download for windows
                </Button>
              </Jumbotron>
            </Col>
          </Row>
        </Grid>

        <Grid>
          <Row>
            <Col md={12}>
              <Jumbotron className="center">
                <h1>requirements</h1>
              </Jumbotron>
              <Col md={6}>
                <h2>Minimum specs</h2>
                <ListGroup>
                  <ListGroupItem>Intel i3</ListGroupItem>
                  <ListGroupItem>4GB RAM</ListGroupItem>
                  <ListGroupItem>Geforce GTX 660 or equivalent</ListGroupItem>
                </ListGroup>
              </Col>
              <Col md={6}>
                <h2>Recommended specs</h2>
                <ListGroup>
                  <ListGroupItem>Intel i5</ListGroupItem>
                  <ListGroupItem>6GB RAM</ListGroupItem>
                  <ListGroupItem>Geforce GTX 1050 or equivalent</ListGroupItem>
                </ListGroup>
              </Col>
            </Col>
          </Row>
        </Grid>


        <Grid className="gallery">
          <Row>
            <Col md={6}>
              <Image responsive src={cryptImg} />
            </Col>
            <Col md={6}>
              <Image responsive src={forestImg} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Image className="center-block" responsive src={leverImg} />
            </Col>
          </Row>
        </Grid>

        <Grid>
          <Row>
            <Col md={12}>
              <ResponsiveEmbed a16by9>
                <embed src="https://player.vimeo.com/video/266937829" />
              </ResponsiveEmbed>
            </Col>
          </Row>
        </Grid>

      </React.Fragment>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js